export const addDiagnose = (item: any) => ({
    type: "ADD_DIAGNOSE",
    payload: item,
  });
export const addDiagnoseNote = (item: any) => ({
    type: "ADD_DIAGNOSE_NOTE",
    payload: item,
  });
export const addAditionalNote = (item: any) => ({
    type: "ADD_ADITIONAL_NOTE",
    payload: item,
  });
export const removeDiagnose = (item: any) => ({
    type: "REMOVE_DIAGNOSE",
    payload: item,
  });
export const addDiagnoses = (item: any) => ({
    type: "ADD_DIAGNOSES",
    payload: item,
  });
export const addDiagnosesImage = (item: any) => ({
    type: "ADD_DIAGNOSES_IMAGE",
    payload: item,
  });
export const addTreatmentImage = (item: any) => ({
    type: "ADD_TREATMENT_IMAGE",
    payload: item,
  });
  export const addPatientComplain = (item: any) => ({
    type: "ADD_COMPLAIN",
    payload: item,
  });
  export const addPatientComplains = (item: any) => ({
    type: "ADD_COMPLAINS",
    payload: item,
  });
  export const removeComplain = (item: any) => ({
    type: "REMOVE_COMPLAIN",
    payload: item,
  });
  export const addPastHistories = (item: any[]) => ({
    type: "ADD_PAST_HISTORIES",
    payload: item,
  });
  export const addPastHistoryItem = (item: any) => ({
    type: "ADD_PAST_HISTORY",
    payload: item,
  });
  export const removePastHistoryItem = (item: any) => ({
    type: "REMOVE_PAST_HISTORY",
    payload: item,
  });
  export const addInvestigations = (item: any) => ({
    type: "ADD_INVESTIGATIONS",
    payload: item,
  });
  export const addInvestigation = (item: any) => ({
    type: "ADD_INVESTIGATION",
    payload: item,
  });


  export const addPrescriptions = (item: any) => ({
    type: "ADD_PRESCRIPTIONS",
    payload: item,
  });
  export const addPrescription = (item: any) => ({
    type: "ADD_PRESCRIPTION",
    payload: item,
  });
  export const updatePrescription = (item: any) => ({
    type: "UPDATE_PRESCRIPTION",
    payload: item,
  });
  export const removePrescription = (item: any) => ({
    type: "REMOVE_PRESCRIPTION",
    payload: item,
  });

  export const addInvestigationImage = (id: any,images:any) => ({
    type: "ADD_INVESTIGATION_IMAGES",
    payload: {id,images},
  });
  export const removeInvestigationImage = (invid: any,imageid:any) => ({
    type: "REMOVE_INVESTIGATION_IMAGES",
    payload: {invid,imageid},
  });
  export const removeInvestigation = (item: any) => ({
    type: "REMOVE_INVESTIGATION",
    payload: item,
  });
  export const addIntraOralSoftTissues = (item: any) => ({
    type: "ADD_INTRA_ORAL_SOFT_TISSUES",
    payload: item,
  });
  export const addIntraOralSoftTissue = (item: any) => ({
    type: "ADD_INTRA_ORAL_SOFT_TISSUE",
    payload: item,
  });
  export const removeIntraOralSoftTissue = (item: any) => ({
    type: "REMOVE_INTRA_ORAL_SOFT_TISSUE",
    payload: item,
  });
  export const setExtraOralExamination = (payload: {
    facialAsymmetry?: string;
    swellings?: string;
    scars?: string;
    lymphadenopathy?: string;
    other?: string;
  }) => ({
    type: "SET_EXTRA_ORAL_EXAMINATION",
    payload,
  });
  export const setOcclusalAssessment = (payload: {
    incisorRelationship?: string;
    canineRelationshipRight?: string;
    canineRelationshipLeft?: string;
    molarRelationshipRight?: string;
    molarRelationshipLeft?: string;
    anteriorGuidance?: string;
    lateralGuidanceRight?: string;
    lateralGuidanceLeft?: string;
  }) => ({
    type: "SET_OCCLUSAL_ASSESSMENT",
    payload,
  });
  export const setBopChart = (payload: string[]) => ({
    type: "SET_BOP_CHART",
    payload,
  });
  export const makeAction = () => ({
    type: "MAKE_ACTION",
  });
  export const setTeethData = (item: any) => ({
    type: "SET_TEETH_DATA",
    payload: item,
  });
  export const updateToothData = (item: any) => ({
    type: "UPDATE_TOOTH_DATA",
    payload: item,
  });
  export const addAdvancedDiagnose = (item: any) => ({
    type: "ADD_ADVANCED_DIAGNOSE",
    payload: item,
  });
  export const updateAdvancedDiagnose = (item: any) => ({
    type: "UPDATE_ADVANCED_DIAGNOSE",
    payload: item,
  });
  export const updateAdvancedDiagnoseBridge = (payload: {
    toothNo: number;
    bridge: { bridgeType?: string; lefttooth?: number; righttooth?: number };
  }) => ({
    type: "UPDATE_ADVANCED_DIAGNOSE_BRIDGE",
    payload,
  });
  export const updateAdvancedDiagnoseAction = (payload: { toothNo: number; action: boolean }) => ({
    type: "UPDATE_ADVANCED_DIAGNOSE_ACTION",
    payload,
  });
  export const removeAdvancedDiagnose = (item: any) => ({
    type: "REMOVE_ADVANCED_DIAGNOSE",
    payload: item,
  });
  export const removeAdvancedDiagnoseSurface = (item: any) => ({
    type: "REMOVE_ADVANCED_DIAGNOSE_SURFACE",
    payload: item,
  });
  export const removeAdvancedDiagnoseRootDiagnose = (item: any) => ({
    type: "REMOVE_ADVANCED_DIAGNOSE_ROOT_DIAGNOSE",
    payload: item,
  });
  export const removeAdvancedDiagnoseRootVariantDiagnose = (item: any) => ({
    type: "REMOVE_ADVANCED_DIAGNOSE_ROOT_VARIANT_DIAGNOSE",
    payload: item,
  });
  export const removeAdvancedDiagnoseRootVariantDiagnoseRootNo = (item: any) => ({
    type: "REMOVE_ADVANCED_DIAGNOSE_ROOT_VARIANT_DIAGNOSE_ROOT_NO",
    payload: item,
  });
  
